module.exports = __webpack_public_path__ + "img/wsczzhjkyypt9.aa9fa6e2.png";